import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import Sidebar from "../Sidebar";
import SalesBox from "./SalesBox";
import {
  BsFillCalendarMonthFill,
  BsFillPieChartFill,
  BsFillCalendarCheckFill,
  BsFillCalendar2DayFill,
} from "react-icons/bs";
import SalesDataTable from "./SalesDataTable";
import { SERVER_PATH } from "../../config/env";
import { Breadcrumbs } from "./../Breadcrumb/index";
import apiClient from "../../utils/api";

export default function SalesReport() {
  const [toggleState, setToggleState] = useState("totalSales");
  const [salesData, setSalesData] = useState([]);
  const [filterData, setFilterData] = useState({
    year: "",
    month: "",
    fromDate: "",
    toDate: "",
  });
  const [yearlySales, setYearlySales] = useState([]);
  const [monthlySales, setMonthlySales] = useState([]);
  const [daySales, setDaySales] = useState([]);

  const toggleClick = (clickState) => {
    setToggleState(clickState);
  };

  const fetchSalesData = async () => {
    await apiClient
      .post(`get/order.php`, {
        status: "confirm",
      })
      .then((res) => {
        setSalesData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const filterDataHandler = (e) => {
    const filterDatas = { ...filterData };
    filterDatas[e.target.name] = e.target.value;
    setFilterData(filterDatas);
  };

  const yearlySalesData = async () => {
    await apiClient
      .post(`get/order.php`, {
        year: filterData.year,
        status: "confirm",
      })
      .then((res) => {
        setYearlySales(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const monthlySalesData = async () => {
    await apiClient
      .post(`get/order.php`, {
        year: filterData.year,
        month: filterData.month,
        status: "confirm",
      })
      .then((res) => {
        setMonthlySales(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const daySalesData = async () => {
    await apiClient
      .post(`get/order.php`, {
        from_date: filterData.fromDate,
        to_date: filterData.toDate,
        status: "confirm",
      })
      .then((res) => {
        setDaySales(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchSalesData();
  }, []);

  return (
    <>
      <Container fluid>
        <Row>
          <Sidebar />
          <Col lg={10} style={{ backgroundColor: "#f1f2f3" }} className="pt-3">
            <Breadcrumbs currentPathName="Sales Details" />
            <Row className="g-4 p-4">
              <SalesBox
                toggleState={() => {
                  toggleClick("totalSales");
                  fetchSalesData();
                }}
                styleName="totalSalesBox"
                title="Total Sales"
                navigatePath="/"
                icons={<BsFillPieChartFill />}
              />
              <SalesBox
                toggleState={() => {
                  toggleClick("yearlySales");
                }}
                styleName="yearSalesBox"
                title="yearly"
                navigatePath="/"
                icons={<BsFillCalendarCheckFill />}
              />
              <SalesBox
                toggleState={() => {
                  toggleClick("monthlySales");
                }}
                styleName="monthSalesBox"
                title="monthly"
                navigatePath="/"
                icons={<BsFillCalendarMonthFill />}
              />
              <SalesBox
                toggleState={() => {
                  toggleClick("daySales");
                }}
                styleName="weekSalesBox"
                title="range"
                navigatePath="/"
                icons={<BsFillCalendar2DayFill />}
              />
            </Row>
            <Row className="px-4">
              <Col className="orderTableDiv">
                {toggleState === "totalSales" ? (
                  <SalesDataTable
                    tableStyle={{ color: "#0984e3", backgroundColor: "#fff" }}
                    tableData={salesData}
                  />
                ) : toggleState === "yearlySales" ? (
                  <>
                    <Row className="salesFilter">
                      <Col className="d-sm-flex align-items-end bg-light mb-3 pb-3 mx-2 rounded shadow-sm salesFilterInputGroup">
                        <Col sm="8" md="auto" className="mt-2 me-3">
                          <label className="d-block">Select Year</label>
                          <Form.Select
  name="year"
  value={filterData.year}
  onChange={(e) => filterDataHandler(e)}
>
  <option value="">Select the year</option>
  {[...Array(5)]
    .map((_, index) => new Date().getFullYear() - 4 + index) // Ascending order
    .map((year) => (
      <option key={year} value={year}>
        {year}
      </option>
    ))}
</Form.Select>


                          {/* <input
                            type="number"
                            placeholder="Enter Year"
                            name="from"
                            maxLength={4}
                            value={filterData.from}
                            onChange={(e) => filterDataHandler(e)}
                          /> */}
                        </Col>
                        {/* <Col sm="4" md="auto" className="mt-2 me-3">
                          <label className="d-block">To Year</label>
                          <input
                            type="number"
                            placeholder="Enter Year"
                            name="to"
                            maxLength={4}
                            value={filterData.to}
                            onChange={(e) => filterDataHandler(e)}
                          />
                        </Col> */}
                        <Col
                          sm="4"
                          md="auto"
                          className="mt-2 salesFilterSubmit">
                          <input
                            type="submit"
                            value="submit"
                            className="py-1 px-2"
                            onClick={yearlySalesData}
                          />
                        </Col>
                      </Col>
                    </Row>
                    <SalesDataTable
                      tableStyle={{ color: "#2ecc71", backgroundColor: "#fff" }}
                      tableData={yearlySales}
                    />
                  </>
                ) : toggleState === "monthlySales" ? (
                  <>
                    <Row className="salesFilter">
                      <Col className="d-sm-flex align-items-end bg-light mb-3 pb-3 mx-2 rounded shadow-sm salesFilterInputGroup">
                        <Col md="auto" className="mt-2 me-3">
                          <label className="d-block">Select Year</label>
                          <Form.Select
  name="year"
  value={filterData.year}
  onChange={(e) => filterDataHandler(e)}
>
  <option value="">Select the year</option>
  {[...Array(new Date().getFullYear() - 2019)] // Number of years from 2020 to current year
    .map((_, index) => 2020 + index) // Generate years from 2020 onward
    .map((year) => (
      <option key={year} value={year}>
        {year}
      </option>
    ))}
</Form.Select>




                          {/* <input
                            type="month"
                            name="year"
                            value={filterData.year}
                            onChange={(e) => filterDataHandler(e)}
                          /> */}
                        </Col>
                        <Col md="auto" className="mt-2 me-3">
                          <label className="d-block">Select Month</label>
                          <Form.Select
                            name="month"
                            value={filterData.month}
                            onChange={(e) => filterDataHandler(e)}>
                            <option>Select Month</option>
                            <option value="1">January</option>
                            <option value="2">February</option>
                            <option value="3">March</option>
                            <option value="4">April</option>
                            <option value="5">May</option>
                            <option value="6">June</option>
                            <option value="7">July</option>
                            <option value="8">August</option>
                            <option value="9">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                          </Form.Select>
                          {/* <input
                            type="month"
                            name="to"
                            value={filterData.to}
                            onChange={(e) => filterDataHandler(e)}
                          /> */}
                        </Col>
                        <Col className="mt-2 salesFilterSubmit">
                          <input
                            type="submit"
                            value="submit"
                            className="px-2"
                            onClick={monthlySalesData}
                            style={{
                              backgroundColor: "#f39c12",
                              borderColor: "#f39c12",
                            }}
                          />
                        </Col>
                      </Col>
                    </Row>
                    <SalesDataTable
                      tableStyle={{ color: "#f39c12", backgroundColor: "#fff" }}
                      tableData={monthlySales}
                    />
                  </>
                ) : toggleState === "daySales" ? (
                  <>
                    <Row className="salesFilter">
                      <Col className="d-sm-flex align-items-end bg-light mb-3 pb-3 mx-2 rounded shadow-sm salesFilterInputGroup">
                        <Col md="auto" className="mt-2 me-3">
                          <label className="d-block">From Date</label>
                          <input
                            type="date"
                            name="fromDate"
                            value={filterData.fromDate}
                            onChange={(e) => filterDataHandler(e)}
                          />
                        </Col>
                        <Col md="auto" className="mt-2 me-3">
                          <label className="d-block">To Date</label>
                          <input
                            type="date"
                            name="toDate"
                            value={filterData.toDate}
                            onChange={(e) => filterDataHandler(e)}
                          />
                        </Col>
                        <Col className="mt-2 salesFilterSubmit">
                          <input
                            type="submit"
                            value="submit"
                            className="py-1 px-2"
                            onClick={daySalesData}
                            style={{
                              backgroundColor: "#c0392b",
                              borderColor: "#c0392b",
                            }}
                          />
                        </Col>
                      </Col>
                    </Row>
                    <SalesDataTable
                      tableStyle={{ color: "#c0392b", backgroundColor: "#fff" }}
                      tableData={daySales}
                    />
                  </>
                ) : null}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}
